module.exports = {
  root: true,
  env: {
    node: true
  },
  'extends': [
    'plugin:vue/vue3-essential',
    'eslint:recommended'
  ],
  parserOptions: {
    parser: 'babel-eslint'
  },
  rules: {
    'no-console': process.env.NODE_ENV === 'production' ? 'warn' : 'off',
    'no-debugger': process.env.NODE_ENV === 'production' ? 'warn' : 'off',
	'vue/no-unused-components': 'off',
	'vue/no-unused-vars': 'off',
	'vue/no-side-effects-in-computed-properties': 'off',
	'vue/no-deprecated-destroyed-lifecycle': 'off',
	'no-mixed-spaces-and-tabs': 'off',
	'no-unused-vars': 'off',
	'no-undef': 'off',
	'vue/require-v-for-key': 'off',
  },
  globals: {
    defineProps: "readonly",
    defineEmits: "readonly",
    defineExpose: "readonly",
    withDefaults: "readonly",
  },
}
